import LoadingBar from './loading-bar';
import Logo from '../../../assets/proofpoint-logo-black.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    background: {
        backgroundColor: theme.palette.background.paper,
        height: '100vh',
        position: 'relative',
        width: '100vw',
    },
    wrapper: {
        left: 'calc(100%/2 - 150px)',
        position: 'fixed',
        textAlign: 'center',
        top: '30%',
        width: 300,
    },
} );

const ProofpointLoadingBar = ( { classes } ) => {
    return (
        <div className={classes.background}>
            <div className={classes.wrapper}>
                <img src={Logo} width={150} alt="Proofpoint Logo" />
                <LoadingBar />
            </div>
        </div>
    );
};

ProofpointLoadingBar.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles( styles )( ProofpointLoadingBar );
